import { useEffect, useState } from "react";
import api from "../lib/api";
import { PageHeader } from "../components/common";
import TaskDialog, { TASK_META } from "../components/TaskDialog";
import { TaskList } from "../components/TaskList";
import { Button } from "../components/ui/button";
import { Plus } from "lucide-react";

const KINDS = [["richiamo", "Richiami"], ["materiale", "Materiali"], ["preventivo", "Preventivi da preparare"]];

export default function Attivita() {
  const [kind, setKind] = useState("richiamo");
  const [state, setState] = useState("open");
  const [items, setItems] = useState([]);
  const [clients, setClients] = useState([]);
  const [dlg, setDlg] = useState({ open: false, task: null });
  const load = async () => { const { data } = await api.get(`/tasks?kind=${kind}${state === "all" ? "" : `&state=${state}`}`); setItems(data); };
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [kind, state]);
  useEffect(() => { api.get("/clients").then((r) => setClients(r.data)).catch(() => {}); }, []);

  return (
    <div>
      <PageHeader title="Attività" subtitle="Richiami, materiali e preventivi da preparare, con lo storico delle voci completate">
        <Button className="bg-brand hover:bg-[#A8472F] text-white" data-testid="attivita-add" onClick={() => setDlg({ open: true, task: null })}><Plus size={16} className="mr-1" /> {TASK_META[kind].add}</Button>
      </PageHeader>
      <div className="flex flex-wrap gap-2 mb-3">
        {KINDS.map(([k, l]) => (
          <button key={k} data-testid={`attivita-tab-${k}`} onClick={() => setKind(k)}
            className={`text-sm px-4 py-2 rounded-full border transition-colors ${kind === k ? "bg-brand text-white border-brand" : "bg-white"}`}>{l}</button>
        ))}
      </div>
      <div className="flex gap-1 mb-4">
        {[["open", "Aperte"], ["done", "Completate"], ["all", "Tutte"]].map(([v, l]) => (
          <button key={v} data-testid={`attivita-state-${v}`} onClick={() => setState(v)}
            className={`text-xs px-3 py-1.5 rounded-full border ${state === v ? "bg-ink text-white" : "bg-white text-muted-foreground"}`}>{l}</button>
        ))}
      </div>
      <div className="card-soft p-4">
        <TaskList kind={kind} items={items} onOpen={(t) => setDlg({ open: true, task: t })} onChanged={load} empty="Nessuna voce in questo elenco." />
      </div>
      <TaskDialog open={dlg.open} kind={kind} task={dlg.task} clients={clients} onClose={() => setDlg({ open: false, task: null })} onChanged={load} />
    </div>
  );
}
